// extracted by mini-css-extract-plugin
export default {"option":"VQBsAA","head":"Py7h2V","name":"Puc3zU","noaction":"uAyQto","description":"AaBJr2","readmore":"doiflQ","more":"sGE2I3"};